import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0202 from "../../../lesson/course-02/lesson-02/lesson";
import lesson0207 from "../../../lesson/course-02/lesson-07/lesson";
import lesson0208 from "../../../lesson/course-02/lesson-08/lesson";
import lesson0209 from "../../../lesson/course-02/lesson-09/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "4ef7ef5b-fe0d-46be-9299-c8c8f4fed5ab",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0202),
    lesson: lesson0202,
  },
  {
    id: "f3552470-c9aa-48ab-8c54-7ed1f4a13d98",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0207),
    lesson: lesson0207,
  },
  {
    id: "93472841-3204-4b8b-923d-06edf40f5c74",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0208),
    lesson: lesson0208,
  },
  {
    id: "ba8f74ad-1694-444b-a078-df95ad4ab432",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0209),
    lesson: lesson0209,
  },
];

export default lessonLinks;
